<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-btn
        color="accent"
        @click="createState()"
        dark
        block
      >
        <v-icon left dark>add</v-icon>
        {{$tc('design.state', 1)}}
      </v-btn>
    </v-flex>

    <v-flex xs12>
      <v-expansion-panel>
        <v-expansion-panel-content
          v-for="(state, index) in states"
          :key="index"
        >
          <div slot="header">
            <b>STATE {{index + 1}}</b>
            <v-btn
              @click.stop="deleteState(index)"
              icon
              ripple
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </div>
          <widget-state-options :index="index"></widget-state-options>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapWidgets } from './WidgetPropertiesUtils';
import WidgetStateOptions from './WidgetStateOptions.vue';

export default {
  components: {
    WidgetStateOptions,
  },
  computed: {
    id: {
      get() {
        return this.$store.getters.getActiveWidget;
      },
    },
    ...mapWidgets(
      [
        {
          path: 'data',
          key: 'states',
        },
      ],
    ),
  },
  methods: {
    createState() {
      let payload = {};

      payload = {
        data: {
          path: 'data',
          key: 'states',
          value: {
            stateOrder: this.states.length,
            positionX: 0,
            positionY: 0,
            rotation: 0,
            time: null,
            opacity: 100,
          },
        },
      };

      this.$store.dispatch(`widget${this.id}/PUSH_TO_ARRAY`, payload);
    },
    deleteState(index) {
      this.$store.dispatch(`widget${this.id}/DELETE_STATE`, index);
      this.$toasted.show('State successfully deleted', { duration: 3000, singleton: true, type: 'success' });
    },
  },
};
</script>

<style scoped>
.v-expansion-panel {
  box-shadow: none;
}
</style>
